import Index from './Index.vue'
import PointersOfMonthAdd from './PointersOfMonthAdd.vue'
import PointersOfMonthDetail from './PointersOfMonthDetail.vue'
import PointersOfMonthEdit from './PointersOfMonthEdit.vue'

export default [
  {
    path: '',
    meta: {
      title: "BERT",
    },
    name: "PointersOfMonth",
    component: Index
  },
  {
    path: 'add',
    meta: {
      title: "BERT - Add Pointer of Month",
    },
    name: "PointersOfMonthAdd",
    component: PointersOfMonthAdd
  },
  {
    path: 'detail/:id',
    meta: {
      title: "BERT - Pointer of Month Detail",
    },
    name: "PointersOfMonthDetail",
    component: PointersOfMonthDetail
  },
  {
    path: 'edit/:id',
    meta: {
      title: "BERT - Edit Pointer of Month",
    },
    name: "PointersOfMonthEdit",
    component: PointersOfMonthEdit
  }
]